<template>
  <button
    @click.stop="click()"
    class="globe-menu-item"
    :style="{
      backgroundColor: bgColor,
      color: bgColor,
      '--color': convertHex
    }"
    :class="{ pulse: pulse }"
  >
    <p class="title" :style="{ color: buttonTitleColor }">
      <slot></slot>
    </p>
    <p class="sub-title" :style="{ color: buttonTextColor }">
      <slot name="sub"></slot>
    </p>
  </button>
</template>

<script>
export default {
  props: {
    textColor: {},
    titleColor: {},
    bgColor: { default: '#002169' },
    pulse: { default: false }
  },
  data() {
    return {}
  },
  methods: {
    click() {
      this.$emit('action')
    }
  },
  computed: {
    buttonTextColor() {
      return this.textColor ? this.textColor : '#fff'
    },
    buttonTitleColor() {
      return this.titleColor ? this.titleColor : '#fff'
    },
    convertHex() {
      let color = this.bgColor
      color = color.replace('#', '')
      const r = parseInt(color.substring(0, 2), 16)
      const g = parseInt(color.substring(2, 4), 16)
      const b = parseInt(color.substring(4, 6), 16)
      return `${r}, ${g}, ${b}`
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../sass/helpers/_variables.scss' as *;
@use '../../../sass/helpers/_mixins.scss' as *;

$animTime: 0.45s;

.globe-menu-item {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 8px 24px;
  @include eclipse(121px);
  /* background: rgba($main-enabled, 1);
  color: white; */
  padding: 0;
  transition: $animTime left, $animTime top, $animTime opacity,
    transform $animTime ease-in-out;
  position: absolute;
  pointer-events: initial;
  color: var(--color);

  p.title {
    color: inherit;
    font-size: 15px;
    font-weight: 400;
    margin-top: -4px;
    line-height: 19px;
  }

  p.sub-title {
    color: inherit;
    font-size: 12px;

    span {
      padding-top: 4px;
      display: inline-block;
    }
  }

  &.pulse {
    animation: pulse 2.5s infinite;
  }

  &:hover {
    transform: scale(1.1);
  }

  &:nth-child(1) {
    left: 193px;
    top: 0;
  }

  &:nth-child(2) {
    left: 280px;
    top: 121px;
  }

  &:nth-child(3) {
    left: 262px;
    top: 263px;
    //animation: pulse 2.5s infinite;
  }

  &:nth-child(4) {
    left: 148px;
    top: 358px;
  }

  &:nth-child(5) {
    left: 0px;
    top: 349px;
  }

  &.move-out {
    //opacity: 0;
    left: 55px;
    top: 133px;
  }
}

@keyframes pulse {
  0% {
    //    color: rgba(234, 0, 41, 0.7);

    // box-shadow: 0 0 0 0 rgba(#000cea, 0.7);
    box-shadow: 0 0 0 0, #00000040 0 8px 24px;
    color: rgba(var(--color), 0.7);
  }

  70% {
    //    color: rgba(var(--color), 0.5);

    box-shadow: 0px 0px 0px 20px, #00000040 0 8px 24px;
    color: rgba(var(--color), 0);
  }

  100% {
    //color: rgba(234, 0, 41, 0);

    box-shadow: 0 0 0 0, #00000040 0 8px 24px;
    color: rgba(var(--color), 0);
  }
}
</style>
